<h2 mat-dialog-title>Filters</h2>

<mat-dialog-content>
  <form id="form" [formGroup]="filterForm" (ngSubmit)="submit()">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Map type</mat-label>
        <mat-select formControlName="mapType">
          @for (mt of mapTypes | keyvalue; track mt.key) {
            <mat-option value="{{ mt.key }}">{{ mt.value }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </p>

    <mat-card class="npdc-leaflet" appearance="outlined">
      <app-leaflet-group
        [geometry]="location"
        [readonly]="false"
        [height]="'400px'"
        (geometryChange)="onGeoSearch($event)"
      />
    </mat-card>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button type="submit" form="form">Search</button>
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
